export const DownloadBaselineUploaderEnum = Object.freeze({
  TITLE: 'Get the Image Uploader',
  BODY: 'Download the image uploader to your Windows computer to start adding images',
  UPLOAD_BUTTON: 'Download',
});
